export const TOGGLE_DARKMODE = 'toggleDarkmode'
export const SET_DARKMODE = 'setDarkmode'
